import React from 'react';
import './ServerTitle.css';

const adjectives = [
  'PVP Faction',
  'RPG Aventure',
  'Mini-Jeux',
  'Légendaire',
];

class Notification extends React.Component {
  constructor() {
    super();
    this.state = {
      index: 0,
      list: adjectives.map((adjective, index) => ({
        id: index,
        name: adjective,
        visibility: 'isNotSet',
      })),
    };
    const { list } = this.state;
    list[0].visibility = 'isVisible';
  }

  componentDidMount() {
    this.timerID = setInterval(
      () => this.tick(),
      2700,
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState((prevState) => {
      const state = { ...prevState };
      state.index += 1;
      if (state.index >= state.list.length) {
        clearInterval(this.timerID);
      } else {
        state.list[state.index - 1].visibility = 'isHidden';
        state.list[state.index].visibility = 'isVisible';
      }
      return state;
    });
  }

  render() {
    const { list } = this.state;
    return (
      <h1 className="animatedTitle">
        <span>Serveur Minecraft&nbsp;</span>
        <span className="zoomWarper">
          {
            list.map(a => (
              <b className={a.visibility} key={a.id}>{a.name}</b>
            ))
          }
        </span>
      </h1>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/home/ServerTitle.js